import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userId: null,
    displayName: null,
    pictureUrl: null,
    accessToken: null,
    familyMemberId: null,
    loginUrl: null
  },
  mutations: {
    setUserId(state, userId) {
      state.userId = userId;
    },

    setDisplayName(state, displayName) {
      state.displayName = displayName;
    },

    setPictureUrl(state, pictureUrl) {
      state.pictureUrl = pictureUrl;
    },
    setAccessToken(state, accessToken) {
      state.accessToken = accessToken;
    },
    setFamilyMemberId(state, familyMemberId) {
      state.familyMemberId = familyMemberId;
    },
    setLoginUrl(state, loginUrl) {
      state.loginUrl = loginUrl;
    },
  },
  actions: {
  },
  modules: {
  }
})
